import { createIcon } from './create-icon';

export const CloseIcon = createIcon('CloseIcon', <path d="M18 6L6 18M6 6l12 12" />);
